import type { Schema } from "@/shared/components/Form/types";
import { OrganizationsAutocompleteQuery } from "@/admin/entities/organizations";
import { PlatformsAutocompleteQuery } from "@/admin/entities/platforms";
import { audienceFilterField } from "@/admin/entities/assistant";
import { topicOptions } from "./topicLabel";

const boolFilterOptions = [
  { label: "Все", value: "" },
  { label: "Да", value: true },
  { label: "Нет", value: false },
];

export const filterSchema: Schema = {
  audience: audienceFilterField,
  organizationId: {
    label: "Организация",
    type: "autocomplete",
    query: OrganizationsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  platformId: {
    label: "Платформа",
    type: "autocomplete",
    query: PlatformsAutocompleteQuery,
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
  },
  topic: {
    label: "Тема",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [{ label: "Все темы", value: "" }, ...topicOptions],
  },
  hasRequest: {
    label: "Есть обращение",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: boolFilterOptions,
  },
  knowledgeGap: {
    label: "Не знал ответ",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: boolFilterOptions,
  },
  hasDislike: {
    label: "Есть дизлайк",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: boolFilterOptions,
  },
  origin: {
    label: "Origin",
    type: "select",
    xs: 12,
    md: 6,
    fullWidth: true,
    priority: "secondary",
    options: [
      { label: "Все", value: "" },
      { label: "BUBBLE", value: "BUBBLE" },
      { label: "ERROR", value: "ERROR" },
    ],
  },
};
